import { REACT_APP_NAME_APP } from './enviroment'

let name_app
if (REACT_APP_NAME_APP) {
    name_app = REACT_APP_NAME_APP
} else {
    name_app = ''
}

// === === === === === Images === === === === ===
const img_app = `${name_app}/assets/img/`
const doc_app = `${name_app}/assets/document/`

// DEFAULT
const img_default_app = `${img_app}/default/`
const img_default_hands_app = `${img_default_app}/hands.png`
const img_default_cover_app = `${img_default_app}/cover.png`

// DOCUMENTS
const img_documents_app = `${doc_app}/Guia-Uso_SeñaTech.pdf`

// LOGOS
const img_logo_app = `${img_app}/logo/`
const img_logo_logoBlack_app = `${img_logo_app}/logo_black.png`
const img_logo_logoBorderWhite_app = `${img_logo_app}/Logo_border_white.png`
const img_logo_logLetterWhite_app = `${img_logo_app}/logo_letter_white.png`
const img_logo_logoLetter_app = `${img_logo_app}/logo_letter.png`
const img_logo_logoWhite_app = `${img_logo_app}/logo_white.png`
const img_logo_logo_app = `${img_logo_app}/logo.png`

// PHOTOS
const img_photo_app = `${img_app}/photo/`


// === === === === === SVGs === === === === ===
const svg_app = `${name_app}/assets/svg/`

// Default
const svg_default_app = `${svg_app}/default/`
const svg_default_file_app = `${svg_default_app}/file.svg`


// Tecnologies
const svg_tecnologies_app = `${svg_app}/tecnologies/`
const svg_tecnologies_google_app = `${svg_tecnologies_app}/google.svg`


export {
    img_documents_app,
    img_default_hands_app,
    img_default_cover_app,

    img_logo_logoBlack_app,
    img_logo_logoBorderWhite_app,
    img_logo_logLetterWhite_app,
    img_logo_logoLetter_app,
    img_logo_logoWhite_app,
    img_logo_logo_app,


    svg_default_file_app,

    svg_tecnologies_google_app,
}